module.exports = __webpack_public_path__ + "static/media/convective-icon.3c28cf7a.svg";